module.exports = __webpack_public_path__ + "img/A1 (8).5d6e0a37.jpg";